export function initializeWorker() {
  return new Worker(new URL('./PdfWorker.js', import.meta.url));
}